// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fkXj","importantInfo":"styles_importantInfo__3f8pL"};